const FromArrEditor = [{
		title: "产品类型：",
		inputtype: "select",
                modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 250,
		height: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
                multiple: false,
		collapseTags: true,
	},
	{
		title: "授权产品：",
		inputtype: "select",
		SelectType: 'SelectAll',
		checkedSelect: false,
		selectFlag: false,
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		AllName: '全选',
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 250,
		height: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: true,
		collapseTags: true,
	},
	{
		title: "省份：",
		inputtype: "select",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 250,
		height: 32,
		disabled: false,
		marginLeft: 65,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: false,
		collapseTags: true,
	},
	{
		title: "城市：",
		inputtype: "select",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 250,
		height: 32,
		disabled: false,
		marginLeft: 65,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: true,
		collapseTags: true,
	},
	{
		title: "医院：",
		inputtype: "selectMultiple",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 250,
		height: 32,
		disabled: false,
		marginLeft: 63,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
	},
	{
		title: "科室：",
		inputinput: "input",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 240,
		height: 32,
		disabled: false,
		marginLeft: 63,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500,
	}, {
		modelvalue: '',
		title: "配送商类型：",
		inputtype: "select",
		multiple: false,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 253,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "配送商：",
		inputtype: "input",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 240,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		title: "备注：",
		inputtype: "textarea",
		modelvalue: '',
		inputflag: true,
		rows: 6,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 240,
		height: 'auto',
		disabled: false,
		marginLeft: 65,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	}
];
export default FromArrEditor;
